'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Facebook, Instagram, Mail, ArrowUpRight } from 'lucide-react';

const TikTokIcon = ({ className }: { className?: string }) => (
      <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
      >
            <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
      </svg>
);

const Footer = () => {
      const currentYear = new Date().getFullYear();

      return (
            <footer className="relative bg-white border-t border-gray-100 pt-20 pb-10 overflow-hidden">

                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full pointer-events-none">
                        <div className="absolute top-[20%] left-[10%] w-64 h-64 bg-purple-50 rounded-full blur-3xl opacity-60" />
                        <div className="absolute bottom-[10%] right-[10%] w-64 h-64 bg-pink-50 rounded-full blur-3xl opacity-60" />
                  </div>

                  <div className="container mx-auto px-6 relative z-10">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">

                              <div className="lg:col-span-4 space-y-6">

                                    <Link href="/" className="relative block w-40 h-12">
                                          <Image
                                                src="/logo.svg"
                                                alt="Gyno Club"
                                                fill
                                                className="object-contain object-left"
                                                priority
                                          />
                                    </Link>

                                    <p className="text-gray-500 leading-relaxed max-w-sm text-sm">
                                          Şehrin dinamik kadınları için tasarlanmış; ayrıcalıklar, deneyimler ve fırsatlarla dolu yeni nesil yaşam kulübü.
                                    </p>

                                    <div className="flex items-center gap-3 pt-2">
                                          <SocialLink href="https://instagram.com/gynoclub" icon={<Instagram className="w-5 h-5" />} label="Instagram" />
                                          <SocialLink href="https://facebook.com/gynoclub" icon={<Facebook className="w-5 h-5" />} label="Facebook" />
                                          <SocialLink href="https://tiktok.com/@gynoclub" icon={<TikTokIcon className="w-5 h-5" />} label="TikTok" />
                                    </div>
                              </div>

                              <div className="lg:col-span-2 lg:col-start-6 space-y-6">
                                    <h4 className="text-gray-900 font-bold text-lg">Keşfet</h4>
                                    <ul className="space-y-3">
                                          <FooterLink href="#">Ana Sayfa</FooterLink>
                                          <FooterLink href="#features">Özellikler</FooterLink>
                                          <FooterLink href="#how-it-works">Nasıl Çalışır?</FooterLink>
                                          <FooterLink href="#brands">Markalar</FooterLink>
                                    </ul>
                              </div>

                              <div className="lg:col-span-2 space-y-6">
                                    <h4 className="text-gray-900 font-bold text-lg">Kurumsal</h4>
                                    <ul className="space-y-3">
                                          {/* <FooterLink href="/hakkimizda">Hakkımızda</FooterLink> */}
                                          <FooterLink href="/privacy-policy">Gizlilik Politikası</FooterLink>
                                          {/* <FooterLink href="/kullanim-kosullari">Kullanım Koşulları</FooterLink>
                                          <FooterLink href="/iletisim">İletişim</FooterLink> */}
                                    </ul>
                              </div>

                              <div className="lg:col-span-4 lg:col-start-10 space-y-6">

                                    <div>
                                          <h4 className="text-gray-900 font-bold text-lg mb-4">Bize Ulaşın</h4>
                                          <a
                                                href="mailto:info@gynoclub.com.tr"
                                                className="flex items-center gap-3 text-gray-500 hover:text-[#6320EE] transition-colors group"
                                          >
                                                <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-[#6320EE] group-hover:text-white transition-all">
                                                      <Mail className="w-4 h-4" />
                                                </div>
                                                <span className="text-sm font-medium">info@gynoclub.com.tr</span>
                                          </a>
                                    </div>

                                    <div className="p-5 rounded-3xl bg-gray-50 border border-gray-100 flex flex-col gap-4">

                                          <div className="flex items-center gap-4">
                                                <div className="relative w-16 h-16 bg-white p-1 rounded-xl shadow-sm border border-gray-100 shrink-0">
                                                      <Image
                                                            src="/app-qr.svg"
                                                            alt="Scan QR"
                                                            width={64}
                                                            height={64}
                                                            className="object-contain"
                                                      />
                                                </div>
                                                <div className="flex flex-col">
                                                      <span className="text-xs font-bold text-[#6320EE] uppercase tracking-wide mb-1">Hemen İndir</span>
                                                      <p className="text-xs text-gray-500 leading-snug">
                                                            Kameranızı okutun ve ayrıcalıklar dünyasına katılın.
                                                      </p>
                                                </div>
                                          </div>

                                          <Link
                                                href="https://gynoclub.com.tr/app"
                                                target="_blank"
                                                className="group relative flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-linear-to-r from-[#6320EE] to-[#DA38E2] text-white font-bold text-sm shadow-lg shadow-purple-500/20 hover:shadow-purple-500/40 hover:-translate-y-0.5 transition-all overflow-hidden"
                                          >
                                                <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                                                <span className="relative flex items-center gap-2">
                                                      Uygulamayı İndir
                                                      <ArrowUpRight className="w-4 h-4" />
                                                </span>
                                          </Link>

                                    </div>

                              </div>

                        </div>

                        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between gap-4">
                              <p className="text-gray-500 text-sm text-center md:text-left">
                                    &copy; {currentYear} Gyno Club. Tüm hakları saklıdır.
                              </p>
                              <div className="flex items-center gap-6">
                                    <span className="text-gray-400 text-sm flex items-center gap-1">
                                          Made with <span className="text-red-500 animate-pulse">❤</span> for Women
                                    </span>
                              </div>
                        </div>
                  </div>
            </footer>
      );
};

const SocialLink = ({ href, icon, label }: { href: string, icon: React.ReactNode, label: string }) => (
      <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="w-10 h-10 rounded-full bg-white border border-gray-100 shadow-sm flex items-center justify-center text-gray-600 hover:bg-[#6320EE] hover:border-[#6320EE] hover:text-white transition-all duration-300 hover:-translate-y-1"
      >
            {icon}
      </a>
);

const FooterLink = ({ href, children }: { href: string, children: React.ReactNode }) => (
      <li>
            <Link
                  href={href}
                  className="text-gray-500 hover:text-[#6320EE] transition-colors text-sm font-medium flex items-center gap-2 group w-fit"
            >
                  <span className="w-1.5 h-1.5 rounded-full bg-gray-300 group-hover:bg-[#6320EE] transition-colors" />
                  {children}
            </Link>
      </li>
);

export default Footer;